<app-menu-common url="hr"></app-menu-common>

@if (hrService.backendMissing()) {
	<div class="hr-backend-warn">Backend RH non déployé : données indisponibles (voir docs/backend-brief-hr2.md).</div>
}

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
	<div class="flexrow hr-header">
		<button mat-icon-button type="button" aria-label="Retour à la liste" (click)="onBack()">
			<mat-icon>arrow_back</mat-icon>
		</button>
		<h2>{{ pageTitle }}</h2>
		@if (isLeft) { <span class="left-chip">Parti</span> }
		<span class="spacer"></span>
		@if (isSelf && current) {
			<!-- R9 — droit d'accès (art. 15 RGPD) : la personne emporte copie de ses données. -->
			<button mat-stroked-button type="button" id="exportmydatabutton" [disabled]="exportingMyData"
				(click)="onExportMyData()"
				matTooltip="Télécharge un fichier JSON rassemblant votre fiche, vos absences, pointages, compteurs, repas, contrats et clôtures de congés (droit d'accès, art. 15 RGPD).">
				<mat-icon>download</mat-icon>&nbsp;{{ exportingMyData ? 'Préparation…' : 'Exporter mes données (RGPD)' }}
			</button>
		}
		<button mat-flat-button color="primary" type="submit" [disabled]="saving" id="saveemployeebutton">
			{{ saving ? 'Enregistrement…' : (isHrManager ? 'Enregistrer' : 'Enregistrer mes coordonnées') }}
		</button>
	</div>

	<div class="pagecontent employee-page">

		@if (isSelf && !isHrManager) {
			<div class="self-notice">
				<mat-icon>info</mat-icon>
				<span>
					Votre fiche. Vous y corrigez vos <strong>coordonnées</strong> ; contrat, rémunération,
					affectation et rôles relèvent du responsable des ressources humaines.
				</span>
			</div>
		}

		@if (isHrManager) {
		<section class="emp-card person-card">
			<h3><mat-icon>person</mat-icon>Personne</h3>

			@if (!formGroup.get('id')?.value) {
				<mat-button-toggle-group class="person-mode" [value]="personMode" (change)="personMode = $event.value">
					<mat-button-toggle value="existing">Utilisateur existant</mat-button-toggle>
					<mat-button-toggle value="new">Nouvelle personne</mat-button-toggle>
				</mat-button-toggle-group>
			}

			@if (personMode === 'existing' || formGroup.get('id')?.value) {
				<mat-form-field class="full">
					<mat-label>Personne liée à la fiche</mat-label>
					<mat-select formControlName="id_user">
						@for (u of users; track u.id) {
							<mat-option [value]="u.id">{{ userLabel(u) }}</mat-option>
						}
					</mat-select>
					<mat-hint>{{ users.length === 0 ? 'Aucun utilisateur libre — passez sur « Nouvelle personne »' : 'Un employé = un utilisateur Mercasell' }}</mat-hint>
				</mat-form-field>
			} @else {
				<div class="flexrow new-person">
					<mat-form-field>
						<mat-label>Prénom</mat-label>
						<input matInput [formControl]="newUserFirst">
					</mat-form-field>
					<mat-form-field>
						<mat-label>Nom</mat-label>
						<input matInput [formControl]="newUserLast" (keyup.enter)="onCreateUser()">
					</mat-form-field>
					<button mat-flat-button color="primary" type="button" (click)="onCreateUser()"
						[disabled]="creatingUser || !newUserLast.value">
						{{ creatingUser ? 'Création…' : 'Créer et lier' }}
					</button>
				</div>
				<p class="card-hint">La personne est créée sans accès à l'application — un login pourra lui être donné plus tard.</p>
			}
		</section>

		<section class="emp-card roles-card">
			<h3>
				<mat-icon>workspace_premium</mat-icon>Rôles
				<span class="live-chip">enregistré immédiatement</span>
			</h3>
			<p class="card-hint field-why">
				Ce que sait faire cette personne. Les rôles décident des <strong>services où elle peut être planifiée</strong> :
				un service n'accepte que les rôles qu'il admet (page Établissements &amp; services).
			</p>
			@if (!linkedUserId) {
				<p class="card-hint">Choisissez ou créez d'abord la personne ci-dessus.</p>
			} @else {
				<div class="roles-grid">
					@for (r of roles; track r.id) {
						<mat-checkbox [checked]="roleChecked(r.id!)" [disabled]="!isHrManager || savingRoles"
							(change)="onToggleRole(r.id!)">{{ r.name }}</mat-checkbox>
					}
				</div>
				<div class="roles-summary">{{ roleSummary }}</div>
				<p class="card-hint">
					« Responsable RH » n'est modifiable que par un Super Admin : il ouvre l'accès aux
					fiches, salaires, congés et heures de tout le personnel.
				</p>
			}
		</section>
		}

		<section class="emp-card">
			<h3><mat-icon>call</mat-icon>Contact <span class="optional-chip">facultatif</span></h3>
			<mat-form-field class="full">
				<mat-label>Téléphone portable</mat-label>
				<input matInput type="tel" [formControl]="phoneCtrl" placeholder="06 12 34 56 78">
			</mat-form-field>
			<mat-form-field class="full">
				<mat-label>Email</mat-label>
				<input matInput type="email" [formControl]="emailCtrl" placeholder="prenom.nom@exemple.fr">
			</mat-form-field>
			<mat-form-field class="full">
				<mat-label>Adresse</mat-label>
				<input matInput [formControl]="streetCtrl" placeholder="246 chemin des Institutrices">
			</mat-form-field>
			<div class="flexrow pair">
				<mat-form-field class="zip-field">
					<mat-label>Code postal</mat-label>
					<input matInput [formControl]="zipCtrl" placeholder="83190" maxlength="5">
				</mat-form-field>
				<mat-form-field>
					<mat-label>Ville</mat-label>
					<input matInput [formControl]="cityCtrl" placeholder="Ollioules">
				</mat-form-field>
			</div>
		</section>

		@if (isHrManager) {
		<!-- IDENTITÉ DE PAIE — ne sert pas au planning, mais aux TIERS : l'émetteur de titres-
		     restaurant exige civilité, naissance et adresse dans son fichier de commande, et le
		     matricule est ce qui rapproche la personne d'un mois sur l'autre. -->
		<section class="emp-card">
			<h3><mat-icon>fingerprint</mat-icon>Identité de paie</h3>
			<div class="flexrow pair">
				<mat-form-field>
					<mat-label>Civilité</mat-label>
					<mat-select [formControl]="genderCtrl">
						<mat-option [value]="null">—</mat-option>
						<mat-option value="M">Monsieur</mat-option>
						<mat-option value="F">Madame</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field>
					<mat-label>Date de naissance</mat-label>
					<input matInput [matDatepicker]="birthPicker" [formControl]="birthDateCtrl">
					<mat-datepicker-toggle matIconSuffix [for]="birthPicker"></mat-datepicker-toggle>
					<mat-datepicker #birthPicker></mat-datepicker>
				</mat-form-field>
			</div>
			<p class="card-hint">
				L'émetteur de titres-restaurant exige la civilité en toutes lettres et la date de
				naissance ; l'adresse postale du bloc <b>Contact</b> sert à la livraison, et le
				<b>Code paie</b> ci-dessous au rapprochement d'un mois sur l'autre.
			</p>
		</section>

		<section class="emp-card">
			<h3><mat-icon>badge</mat-icon>Contrat &amp; statut</h3>
			<div class="flexrow pair">
				<mat-form-field>
					<mat-label>Entré dans l'entreprise le</mat-label>
					<input matInput [matDatepicker]="hirePicker" formControlName="hire_date">
					<mat-datepicker-toggle matIconSuffix [for]="hirePicker"></mat-datepicker-toggle>
					<mat-datepicker #hirePicker></mat-datepicker>
				</mat-form-field>
				<mat-form-field>
					<mat-label>Sorti le</mat-label>
					<input matInput [matDatepicker]="leavePicker" [formControl]="leaveDateCtrl">
					<mat-datepicker-toggle matIconSuffix [for]="leavePicker"></mat-datepicker-toggle>
					<mat-datepicker #leavePicker></mat-datepicker>
					<mat-hint>Vide tant qu'elle est présente</mat-hint>
				</mat-form-field>
			</div>
			<div class="flexrow pair">
				<mat-form-field>
					<mat-label>Heures / semaine</mat-label>
					<input matInput type="number" min="0" step="0.5" formControlName="contract_hours_week">
					<span matTextSuffix>h</span>
				</mat-form-field>
				<!-- Code de pointage : il s'écrit, il ne se relit pas. Le champ reste vide tant qu'on ne
				     veut pas le CHANGER — l'enregistrer vide conserve le code en place. -->
				<mat-form-field class="pin">
					<mat-label>{{ hasPin ? 'Nouveau code pointeuse' : 'Code pointeuse' }}</mat-label>
					<input matInput maxlength="8" inputmode="numeric" formControlName="pin"
						[placeholder]="hasPin ? '••••' : ''" autocomplete="off"
						[matTooltip]="pinTip" matTooltipShowDelay="400">
					<mat-hint>{{ pinHint }}</mat-hint>
					@if (hasPin) {
						<button matSuffix mat-icon-button type="button" aria-label="Retirer le code de pointage"
							matTooltip="Retirer le code : la personne ne pourra plus pointer au kiosque"
							(click)="onClearPin(); $event.stopPropagation()">
							<mat-icon>key_off</mat-icon>
						</button>
					}
				</mat-form-field>
			</div>

			<!-- L2.3 — modulation : n'a de sens que sur un emploi du temps à cycle multiple. -->
			@if (cycleWeeks > 1) {
				<div class="modulation">
					<span class="card-hint">
						<b>Modulation</b> — l'emploi du temps tourne sur {{ cycleWeeks }} semaines. Vous pouvez
						donner un volume différent à chacune (34 / 35 / 36…) : une semaine à 34 h ne sera alors
						PAS comptée en déficit d'une heure.
					</span>
					<div class="flexrow cycle-hours">
						@for (h of cycleHours; track $index) {
							<mat-form-field class="cycle-week">
								<mat-label>Semaine {{ $index + 1 }}</mat-label>
								<input matInput type="number" min="0" step="0.5" [value]="h"
									(change)="onCycleHourChange($index, $any($event.target).value)">
								<span matTextSuffix>h</span>
							</mat-form-field>
						}
						@if (modulationActive) {
							<button mat-button type="button" (click)="onClearModulation()">
								<mat-icon>close</mat-icon>&nbsp;Désactiver la modulation
							</button>
						}
					</div>
				</div>
			}
			<!-- ============================================================
			     STATUT × DÉCOMPTE — deux axes INDÉPENDANTS, et c'est du droit
			     ============================================================
			     Croire que « cadre » veut dire « on ne compte pas » est faux dans les deux sens :
			     un cadre intégré à l'horaire collectif touche ses heures sup comme tout le monde,
			     et le forfait jours est ouvert aux non-cadres autonomes (L3121-58 2°). -->
			<div class="worktime-row status-row">
				<span class="card-hint">
					<b>Statut et décompte du temps</b> — deux questions <b>séparées</b>. Le statut cadre
					ne dispense jamais de compter les heures : un cadre qui suit l'horaire collectif
					touche ses majorations comme les autres. Et le forfait jours n'est pas réservé aux
					cadres — un salarié autonome peut y être (L3121-58).
				</span>
				<div class="flexrow pair">
					<mat-form-field>
						<mat-label>Statut</mat-label>
						<mat-select [formControl]="statusCtrl" (selectionChange)="onStatusChange()">
							<mat-option value="non_cadre">Non-cadre</mat-option>
							<mat-option value="cadre">Cadre</mat-option>
							<mat-option value="cadre_dirigeant">Cadre dirigeant</mat-option>
							<mat-option value="tns">Gérant non salarié (TNS)</mat-option>
						</mat-select>
						<mat-hint>Classification, retraite, convention — pas le décompte</mat-hint>
					</mat-form-field>
					<mat-form-field>
						<mat-label>Décompte du temps</mat-label>
						<mat-select [formControl]="timeSchemeCtrl" (selectionChange)="onSchemeChange()">
							<mat-option value="hours">Heures comptées (horaire collectif)</mat-option>
							<mat-option value="forfait_hours">Forfait en heures</mat-option>
							<mat-option value="forfait_days">Forfait annuel en jours</mat-option>
							<mat-option value="none">Hors décompte</mat-option>
						</mat-select>
						@if (schemeLocked) {
							<mat-hint>Imposé par le statut : ni durée du travail, ni heures supplémentaires</mat-hint>
						}
					</mat-form-field>
				</div>
				<div class="scheme-hint" [class.no-count]="!countsHours">
					<mat-icon>{{ countsHours ? 'timer' : 'timer_off' }}</mat-icon>
					<span>{{ schemeHint }}</span>
				</div>
				@if (isForfaitDays) {
					<div class="flexrow pair">
						<mat-form-field>
							<mat-label>Jours travaillés par an</mat-label>
							<input matInput type="number" min="1" max="235" step="1" [formControl]="forfaitDaysCtrl">
							<span matTextSuffix>j</span>
							<mat-hint>218 jours par défaut, journée de solidarité comprise (L3121-64)</mat-hint>
						</mat-form-field>
						<span class="spacer"></span>
					</div>
				}
			</div>

			<!-- N2 — ce que ce contrat a de particulier face à la convention de l'établissement.
			     « Automatique » partout = les règles de l'entreprise s'appliquent telles quelles.
			     Sans décompte horaire, ces réglages ne servent plus à rien : on les masque. -->
			@if (countsHours) {
			<div class="worktime-row">
				<span class="card-hint">
					<b>Temps de travail</b> — un contrat sous 35 h fait des heures <b>complémentaires</b>
					(majorées dès la première), pas des heures supplémentaires. Laissez « Automatique »
					pour suivre les règles de l'établissement.
				</span>
				<div class="flexrow pair">
					<!-- `canSelectNullableOptions` : sans lui Material traite une option de valeur
					     `null` comme un simple « reset » et n'affiche RIEN dans le champ — les
					     quatre listes de ce bloc restaient désespérément vides. -->
					<mat-form-field>
						<mat-label>Nature du contrat</mat-label>
						<mat-select [formControl]="contractKindCtrl" canSelectNullableOptions>
							<mat-option [value]="null">Automatique (d'après le volume horaire)</mat-option>
							<mat-option value="full_time">Temps plein</mat-option>
							<mat-option value="part_time">Temps partiel</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field>
						<mat-label>Max. heures complémentaires</mat-label>
						<mat-select [formControl]="complementaryLimitCtrl" canSelectNullableOptions>
							<mat-option [value]="null">Comme l'établissement</mat-option>
							<mat-option [value]="0.1">1/10 du contrat (L3123-28)</mat-option>
							<mat-option [value]="0.3333333333333333">1/3 du contrat (avec accord)</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="flexrow pair">
					<mat-form-field>
						<mat-label>Jours travaillés par semaine</mat-label>
						<input matInput type="number" min="1" max="7" step="1" [formControl]="weekWorkingDaysCtrl"
							placeholder="comme l'établissement">
						<span matTextSuffix>j</span>
					</mat-form-field>
					<mat-form-field>
						<mat-label>Base d'une journée</mat-label>
						<input matInput type="number" min="0" step="0.25" [formControl]="dayBaseHoursCtrl"
							placeholder="calculée : contrat ÷ jours">
						<span matTextSuffix>h</span>
					</mat-form-field>
				</div>
				<div class="worktime-recap">{{ dayBaseHint }}</div>
				<div class="flexrow pair">
					<mat-form-field>
						<mat-label>Heures majorées : préférence</mat-label>
						<mat-select [formControl]="rcrDefaultCtrl" canSelectNullableOptions>
							<mat-option [value]="null">Comme l'établissement</mat-option>
							<mat-option value="pay">Se les faire payer</mat-option>
							<mat-option value="rest">Les récupérer en repos</mat-option>
						</mat-select>
						<mat-hint>S'applique quand la convention laisse le choix au salarié.
							Le récapitulatif du mois permet ensuite d'ajuster ligne par ligne.</mat-hint>
					</mat-form-field>
					<mat-form-field>
						<mat-label>Congés payés dans l'assiette</mat-label>
						<mat-select [formControl]="leaveBasisCtrl" canSelectNullableOptions>
							<mat-option [value]="null">Comme l'établissement</mat-option>
							<mat-option value="worked_plus_paid_leave">Oui (Cass. 10 sept. 2025)</mat-option>
							<mat-option value="worked">Non — accord ou usage contraire</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</div>
			}

			<!-- La convention collective qui régit ce contrat, avec de quoi ALLER LA LIRE : le texte
			     officiel sur Légifrance (lien tiré de la base KALI de l'État) et, si l'entreprise
			     l'a déposé, le PDF intégral. Réglée une fois dans Organisation ▸ Règles de paie. -->
			@if (convention; as ccn) {
				<div class="ccn-row">
					<span class="card-hint">
						<b>Convention collective</b> — c'est elle qui fixe les majorations, le contingent
						d'heures supplémentaires et les minima applicables à ce contrat.
					</span>
					<div class="flexrow ccn-links">
						<span class="ccn-num">IDCC {{ ccn.idcc }}</span>
						<span class="ccn-label" [matTooltip]="ccn.title">{{ ccn.label }}</span>
						<a mat-button target="_blank" rel="noopener" [href]="ccn.url">
							<mat-icon>gavel</mat-icon>&nbsp;Légifrance
						</a>
						@if (ccn.pdf) {
							<a mat-button target="_blank" rel="noopener" [href]="ccn.pdf">
								<mat-icon>picture_as_pdf</mat-icon>&nbsp;PDF intégral
							</a>
						}
					</div>
				</div>
			}

			<!-- Couleur d'identité : c'est elle qui distingue les personnes en vue Postes. -->
			<div class="color-row">
				<span class="card-hint">
					<b>Couleur</b> — elle identifie cette personne sur le planning en <b>vue Postes</b>.
				</span>
				<div class="color-picker">
					<input type="color" [formControl]="colorCtrl" aria-label="Couleur de cette personne">
					<div class="swatches">
						@for (c of palette; track c) {
							<button type="button" class="swatch" [class.on]="colorCtrl.value === c"
								[style.background]="c" [attr.aria-label]="'Couleur ' + c"
								(click)="colorCtrl.setValue(c)"></button>
						}
					</div>
					<span class="color-preview" [style.background]="colorCtrl.value"
						[style.color]="(colorCtrl.value || '#000000') | hrTextOn">Aperçu</span>
				</div>
			</div>

			<div class="status-row">
				<mat-slide-toggle formControlName="is_active">Employé actif</mat-slide-toggle>
				<span class="card-hint">Décochez quand la personne quitte l'entreprise : elle disparaît des plannings et de la pointeuse, l'historique reste.</span>
			</div>
		</section>
		}

		<!-- L1.2 — ce que le rapport de paie exige pour considérer le profil complet. -->
		@if (isHrManager) {
		<section class="emp-card">
			<h3>
					<mat-icon>payments</mat-icon>Données salariales
					@if (sensitive.unlocked()) {
						<button mat-icon-button type="button" class="lock-btn" (click)="sensitive.lock()" matTooltip="Masquer et verrouiller" aria-label="Masquer et verrouiller">
							<mat-icon>lock_open</mat-icon>
						</button>
					}
				</h3>

				@if (!sensitive.unlocked()) {
					<!-- Verrouillé : rien n'est rendu tant que le mot de passe n'est pas retapé. -->
					<div class="sensitive-locked">
						<mat-icon>lock</mat-icon>
						<p>Salaire, taux horaire et classification — informations sensibles.</p>
						<button mat-stroked-button type="button" (click)="revealSalary()">
							<mat-icon>visibility</mat-icon>&nbsp;Afficher (mot de passe requis)
						</button>
					</div>
				} @else {
			<p class="card-hint">
				Ces champs alimentent l'onglet <b>Rapport</b> : un profil incomplet y est signalé
				avant l'export au comptable.
			</p>
			<div class="flexrow pair">
				<mat-form-field>
					<mat-label>Type de contrat</mat-label>
					<mat-select [formControl]="contractTypeCtrl" canSelectNullableOptions>
						<mat-option [value]="null">—</mat-option>
						@for (t of contractTypes; track t) {
							<mat-option [value]="t">{{ t }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
				<mat-form-field>
					<mat-label>Fin de période d'essai</mat-label>
					<input matInput [matDatepicker]="trialPicker" [formControl]="trialEndCtrl">
					<mat-datepicker-toggle matIconSuffix [for]="trialPicker"></mat-datepicker-toggle>
					<mat-datepicker #trialPicker></mat-datepicker>
					<mat-hint>Laisser vide si sans objet</mat-hint>
				</mat-form-field>
			</div>
			<div class="flexrow pair">
				<mat-form-field>
					<mat-label>Salaire brut mensuel</mat-label>
					<input matInput type="number" min="0" step="10" [formControl]="grossMonthlyCtrl">
					<span matTextSuffix>€</span>
				</mat-form-field>
				<mat-form-field>
					<mat-label>Taux horaire</mat-label>
					<input matInput type="number" min="0" step="0.0001" [formControl]="hourlyRateCtrl">
					<span matTextSuffix>€</span>
				</mat-form-field>
			</div>
			<mat-form-field class="full">
				<mat-label>Qualification</mat-label>
				<input matInput [formControl]="qualificationCtrl" placeholder="Technicien, Vendeur…">
			</mat-form-field>

			<!-- Classification conventionnelle (IDCC 1982) + clé de rapprochement avec la paie. -->
			<div class="flexrow triple">
				<mat-form-field>
					<mat-label>Niveau</mat-label>
					<input matInput [formControl]="levelCtrl" placeholder="I, III, IV…">
				</mat-form-field>
				<mat-form-field>
					<mat-label>Coefficient</mat-label>
					<input matInput [formControl]="coefficientCtrl" placeholder="300">
				</mat-form-field>
				<mat-form-field>
					<mat-label>Position</mat-label>
					<input matInput [formControl]="positionCtrl" placeholder="1.1">
				</mat-form-field>
			</div>
			<mat-form-field class="full">
				<mat-label>Code paie</mat-label>
				<input matInput [formControl]="payrollCodeCtrl" placeholder="0039">
				<mat-hint>Code du salarié dans le logiciel de paie — sert à rapprocher les bulletins</mat-hint>
			</mat-form-field>
			<div class="status-row">
				<mat-slide-toggle [formControl]="mealVouchersCtrl">Bénéficie des titres-restaurant</mat-slide-toggle>
				<span class="card-hint">Sans effet tant que la règle n'est pas activée dans Paramètres ▸ Règles de paie.</span>
			</div>
			@if (mealVouchersCtrl.value) {
				<div class="status-row">
					<mat-slide-toggle [formControl]="mealPhysicalCardCtrl">Commander une carte physique</mat-slide-toggle>
					<span class="card-hint">
						À cocher pour une PREMIÈRE commande seulement : ensuite, le crédit mensuel se recharge
						sur la carte déjà en main.
					</span>
				</div>
			}
		}
		</section>
		}

		@if (isHrManager) {
		<section class="emp-card assign-card">
			<h3><mat-icon>storefront</mat-icon>Affectation</h3>

			<div class="assign-grid">
				<div class="assign-field">
					<mat-form-field class="full">
						<mat-label>Établissement principal</mat-label>
						<mat-select formControlName="id_store">
							@for (s of stores; track s.id) {
								<mat-option [value]="s.id">{{ s.name }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
					<p class="field-why">Son rattachement habituel. Il est toujours compté dans la mobilité ci-contre.</p>
				</div>

				<div class="assign-field">
					<mat-form-field class="full">
						<mat-label>Emploi du temps habituel</mat-label>
						<mat-select formControlName="id_schedule" canSelectNullableOptions>
							<mat-option [value]="null">— Aucun —</mat-option>
							@for (g of scheduleGroups; track g.store.id) {
								<mat-optgroup [label]="g.store.name ?? ''">
									@for (s of g.schedules; track s.id) {
										<mat-option [value]="s.id">{{ scheduleLabel(s) }}</mat-option>
									}
								</mat-optgroup>
							}
						</mat-select>
					</mat-form-field>
					<p class="field-why">
						Les horaires types qu'elle suit par défaut, créés dans <strong>Horaires</strong>.
						Facultatif — un service sans horaires n'apparaît pas ici.
					</p>
				</div>
			</div>

			<div class="mobility-block">
				<div class="block-title">Mobilité — établissements où elle peut travailler</div>
				<p class="field-why">Cochez-en autant que nécessaire : elle sera proposée dans les plannings de chacun d'eux.</p>
				<div class="mobility-grid">
					@for (s of stores; track s.id) {
						<label class="mobility-item" [class.locked]="isDefaultStore(s.id!)">
							<mat-checkbox [checked]="isInMobility(s.id!)" [disabled]="isDefaultStore(s.id!)"
								(change)="onToggleMobility(s.id!)">{{ s.name }}</mat-checkbox>
							@if (isDefaultStore(s.id!)) { <span class="main-chip">principal</span> }
						</label>
					}
				</div>
			</div>

			<div class="posts-block">
				<div class="block-title">Postes ouverts à cette personne</div>
				<p class="field-why">
					Croisement de sa <strong>mobilité</strong> et de ses <strong>rôles</strong> : les services où elle peut
					réellement être planifiée. Un poste barré indique ce qui lui manque.
				</p>
				@for (g of postGroups; track g.store.id) {
					<div class="post-store">
						<div class="post-store-name">
							{{ g.store.name }}
							@if (g.isDefault) { <span class="main-chip">principal</span> }
						</div>
						@if (g.posts.length === 0) {
							<div class="post-empty">Aucun service déclaré — à créer dans Établissements &amp; services.</div>
						} @else {
							<div class="post-list">
								@for (p of g.posts; track p.activity.id) {
									<div class="post" [class.blocked]="!!p.blocked">
										<mat-icon class="post-icon">{{ p.blocked ? 'block' : 'check_circle' }}</mat-icon>
										<span class="post-name">{{ p.activity.name }}</span>
										@if (p.blocked) {
											<span class="post-reason">{{ p.blocked }}</span>
											@if (!p.scheduleName) {
												<button mat-button type="button" class="post-action" (click)="onOpenSchedule(p)">Créer les horaires</button>
											}
										} @else {
											<span class="post-schedule">horaires : {{ p.scheduleName }}</span>
										}
									</div>
								}
							</div>
						}
					</div>
				} @empty {
					<div class="post-empty">Choisissez un établissement principal pour voir les postes.</div>
				}
			</div>
		</section>
		}

		<!-- L5 — documents RH : pièces c_attach classées par dossier. -->
		@if (current) {
			<section class="emp-card docs-card">
				<h3><mat-icon>folder_shared</mat-icon>Documents</h3>
				<p class="card-hint">
					Contrats, justificatifs, fiches de paie… Un document dont la date d'expiration approche
					est signalé. Les arrêts déposés ici alimentent le contrôle « justificatif manquant » du
					rapport de paie.
				</p>

				@for (g of documentFolders; track g.folder.id) {
					<div class="doc-folder">
						<div class="folder-head">
							<mat-icon>{{ g.folder.icon }}</mat-icon>
							<span class="folder-name">{{ g.folder.name }}</span>
							<span class="folder-count">{{ g.docs.length }}</span>
						</div>
						@if (g.docs.length > 0) {
							<ul class="doc-list">
								@for (d of g.docs; track d.id) {
									<li class="flexrow">
										<span class="doc-name" (click)="onDownloadDocument(d)">{{ d.name || 'Document #' + d.id }}</span>
										<span class="doc-date">{{ docDate(d) }}</span>
										@if (docExpiryLabel(d)) {
											<span class="doc-exp" [class]="docExpiryState(d)">{{ docExpiryLabel(d) }}</span>
										}
										<span class="spacer"></span>
										<button mat-icon-button type="button" matTooltip="Télécharger" aria-label="Télécharger le document" (click)="onDownloadDocument(d)">
											<mat-icon>download</mat-icon>
										</button>
										@if (isHrManager) {
											<button mat-icon-button type="button" matTooltip="Supprimer" aria-label="Supprimer le document" (click)="onDeleteDocument(d)">
												<mat-icon>close</mat-icon>
											</button>
										}
									</li>
								}
							</ul>
						}
					</div>
				}

				@if (isHrManager) {
					<div class="flexrow doc-upload">
						<mat-form-field class="doc-folder-select">
							<mat-label>Dossier</mat-label>
							<mat-select [formControl]="docFolderCtrl">
								@for (f of docFolders; track f.id) {
									<mat-option [value]="f.id">{{ f.name }}</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<mat-form-field class="doc-expiry">
							<mat-label>Expire le</mat-label>
							<input matInput [matDatepicker]="docPicker" [formControl]="docExpiryCtrl">
							<mat-datepicker-toggle matIconSuffix [for]="docPicker"></mat-datepicker-toggle>
							<mat-datepicker #docPicker></mat-datepicker>
							<mat-hint>Facultatif</mat-hint>
						</mat-form-field>
						<button mat-stroked-button type="button" [disabled]="uploadingDoc" (click)="docInput.click()">
							<mat-icon>upload_file</mat-icon>&nbsp;{{ uploadingDoc ? 'Envoi…' : 'Déposer un fichier' }}
						</button>
						<input #docInput type="file" hidden (change)="onPickDocument($event)">
					</div>
				}
			</section>
		}

		<!-- L4 — disponibilités déclarées : « Radia n'est jamais là le mercredi après-midi ». -->
		@if (current) {
			<section class="emp-card avail-card">
				<h3><mat-icon>event_available</mat-icon>Disponibilités déclarées</h3>
				<p class="card-hint">
					Les contraintes récurrentes de la personne. Elles s'affichent sur le planning sous forme
					de repère — <b>elles n'empêchent jamais de la planifier</b>, un remplacement d'urgence
					se négocie.
				</p>

				@if (availabilityRows.length > 0) {
					<ul class="avail-list">
						@for (r of availabilityRows; track r.a.id) {
							<li class="flexrow">
								<span class="avail-dot" [class.unavailable]="r.a.kind === AVAIL_UNAVAILABLE"></span>
								<span>{{ r.label }}</span>
								<span class="spacer"></span>
								@if (isHrManager) {
									<button mat-icon-button type="button" matTooltip="Retirer" aria-label="Retirer cette disponibilité" (click)="onRemoveAvailability(r.a)">
										<mat-icon>close</mat-icon>
									</button>
								}
							</li>
						}
					</ul>
				} @else {
					<p class="card-hint empty">Aucune contrainte déclarée.</p>
				}

				@if (isHrManager) {
					<div class="flexrow avail-form">
						<mat-form-field class="avail-kind">
							<mat-label>Type</mat-label>
							<mat-select [formControl]="availKindCtrl">
								<mat-option [value]="AVAIL_UNAVAILABLE">Indisponible</mat-option>
								<mat-option [value]="AVAIL_AVAILABLE">Disponible</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field class="avail-day">
							<mat-label>Tous les</mat-label>
							<mat-select [formControl]="availWeekdayCtrl">
								@for (d of dayLabels; track d; let i = $index) {
									<mat-option [value]="i + 1">{{ d }}s</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<mat-form-field class="avail-time">
							<mat-label>De</mat-label>
							<input matInput type="time" [formControl]="availStartCtrl">
						</mat-form-field>
						<mat-form-field class="avail-time">
							<mat-label>À</mat-label>
							<input matInput type="time" [formControl]="availEndCtrl">
						</mat-form-field>
						<mat-form-field class="avail-until">
							<mat-label>Jusqu'au</mat-label>
							<input matInput [matDatepicker]="availPicker" [formControl]="availUntilCtrl">
							<mat-datepicker-toggle matIconSuffix [for]="availPicker"></mat-datepicker-toggle>
							<mat-datepicker #availPicker></mat-datepicker>
						</mat-form-field>
						<mat-form-field class="avail-comment">
							<mat-label>Motif</mat-label>
							<input matInput [formControl]="availCommentCtrl" placeholder="Garde des enfants">
						</mat-form-field>
						<button mat-stroked-button type="button" (click)="onAddAvailability()">
							<mat-icon>add</mat-icon>&nbsp;Ajouter
						</button>
					</div>
					<p class="card-hint">
						Horaires vides = toute la journée. « Jusqu'au » vide = sans limite de temps.
					</p>
				}
			</section>
		}

		<!-- FORFAIT JOURS — le compteur qui remplace celui des heures. On décompte des JOURNÉES
		     (L3121-58) : afficher « +3 h » à quelqu'un au forfait jours serait un contresens, et
		     devant un juge l'indice que le forfait n'était pas réellement appliqué. -->
		@if (current && isForfaitDays && forfait; as f) {
			<section class="emp-card counter-card">
				<div class="flexrow counter-head">
					<h3><mat-icon>event_repeat</mat-icon>Forfait annuel en jours</h3>
					<span class="counter-balance" [class.under]="f.rest_days_left < 0"
						matTooltip="Jours de repos qu'il reste à poser cette année">
						{{ f.rest_days_left }} j de repos
					</span>
				</div>
				<div class="forfait-grid">
					<div><span class="k">Forfait</span><span class="v">{{ f.forfait_days }} j</span></div>
					<div><span class="k">Travaillés</span><span class="v">{{ f.worked_days }} j</span></div>
					<div><span class="k">Reste au forfait</span><span class="v">{{ f.remaining_workable }} j</span></div>
					<div><span class="k">Repos dus sur l'année</span><span class="v">{{ f.rest_days_due }} j</span></div>
					<div><span class="k">Repos pris</span><span class="v">{{ f.rest_days_taken }} j</span></div>
				</div>
				<span class="card-hint">
					Les jours de repos sont ce que l'année laisse au-delà du forfait :
					{{ f.workable_days }} jours ouvrés − congés payés − {{ f.forfait_days }} jours de forfait.
					Ce nombre change chaque année selon les fériés qui tombent en semaine.
				</span>
				@for (i of f.issues; track i) {
					<div class="forfait-issue"><mat-icon>warning</mat-icon><span>{{ i }}</span></div>
				}
			</section>
		}

		<!-- L2 — compteur d'heures : le « combien d'heures il a en stock ».
		     Masqué pour qui n'a pas de décompte horaire : un gérant non salarié ou un cadre
		     dirigeant n'a pas de compteur, et un forfait jours a le sien, juste au-dessus. -->
		@if (current && countsHours) {
			<section class="emp-card counter-card">
				<div class="flexrow counter-head">
					<h3><mat-icon>schedule</mat-icon>Compteur d'heures</h3>
					<span class="counter-balance" [class.over]="counterBalance > 0" [class.under]="counterBalance < 0"
						matTooltip="Solde cumulé à la fin de la dernière période affichée">
						{{ counterLabel(counterBalance) }}
					</span>
					<span class="spacer"></span>
					<button mat-button type="button" (click)="counterOpen = !counterOpen">
						<mat-icon>{{ counterOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
						{{ counterOpen ? 'Replier' : 'Voir le détail' }}
					</button>
				</div>
				<p class="card-hint">
					Les heures faites en plus ou en moins du volume de référence, cumulées. C'est ce
					solde qu'on fait récupérer plutôt que de payer.
				</p>

				<!-- Le seul plafond qu'aucune semaine ne peut voir : douze semaines à 45 h sont douze
				     semaines légales prises une à une, mais leur SUITE ne l'est pas (L3121-22). -->
				@if (avg12Issues.length > 0) {
					<div class="avg12-alert">
						<mat-icon>gavel</mat-icon>
						<div>
							<b>Moyenne sur 12 semaines dépassée</b>
							@for (i of avg12Issues; track $index) {
								<div class="avg12-detail">{{ i.detail }}</div>
							}
						</div>
					</div>
				}

				@if (counterOpen) {
					<mat-button-toggle-group [value]="counterGranularity" (change)="onCounterGranularity($event.value)" class="gran">
						<mat-button-toggle value="week">Semaine</mat-button-toggle>
						<mat-button-toggle value="month">Mois</mat-button-toggle>
						<mat-button-toggle value="year">Année</mat-button-toggle>
					</mat-button-toggle-group>

					<div class="counter-scroll">
						<table class="counter-grid">
							<thead>
								<tr>
									<th class="row-label"></th>
									@for (c of counterCells; track c.key) {
										<th [class.unplanned]="!c.planned" [class.pending]="c.pending"
											[matTooltip]="c.pending ? 'Période EN COURS : les heures faites sont affichées, mais elle ne soldera qu\'une fois terminée' : ''">
											{{ c.label }}@if (c.pending) {<mat-icon class="pending-icon">hourglass_top</mat-icon>}
										</th>
									}
								</tr>
							</thead>
							<tbody>
								<tr>
									<td class="row-label">Heures travaillées &amp; absences planning</td>
									@for (c of counterCells; track c.key) {
										<td>{{ c.planned ? (c.worked_min / 60 | number:'1.0-2') : '—' }}</td>
									}
								</tr>
								<tr>
									<td class="row-label">− Absences non incluses dans le compteur</td>
									@for (c of counterCells; track c.key) {
										<td [class.zero]="!c.excluded_absence_min">{{ c.excluded_absence_min / 60 | number:'1.0-2' }}</td>
									}
								</tr>
								<!-- Les congés payés NEUTRALISENT la référence : une semaine de congés ne
								     creuse plus le compteur (Cass. soc. 10 sept. 2025). -->
								<tr>
									<td class="row-label" matTooltip="Congés payés comptés comme du temps de travail dans l'assiette">
										+ dont congés payés assimilés
									</td>
									@for (c of counterCells; track c.key) {
										<td [class.zero]="!c.assimilated_min">{{ c.assimilated_min / 60 | number:'1.0-2' }}</td>
									}
								</tr>
								<tr>
									<td class="row-label">− Volume horaire de référence (contrat)</td>
									@for (c of counterCells; track c.key) {
										<td>{{ c.contract_min / 60 | number:'1.0-2' }}</td>
									}
								</tr>
								<tr class="sep">
									<td class="row-label">= Compteur avant modification manuelle</td>
									@for (c of counterCells; track c.key) {
										<td [class.over]="c.raw_balance > 0" [class.under]="c.raw_balance < 0">
											{{ counterLabel(c.raw_balance) }}
										</td>
									}
								</tr>
								<tr>
									<td class="row-label">Modifications manuelles</td>
									@for (c of counterCells; track c.key) {
										<td [class.zero]="!c.manual_min">{{ c.manual_min ? counterLabel(c.manual_min) : '—' }}</td>
									}
								</tr>
								<tr class="cumul">
									<td class="row-label">= Solde cumulé</td>
									@for (c of counterCells; track c.key) {
										<td [class.over]="c.cumulative > 0" [class.under]="c.cumulative < 0">
											{{ counterLabel(c.cumulative) }}
										</td>
									}
								</tr>
								<!-- Volet RÉCUPÉRATION, distinct du solde d'écart : ce sont des heures
								     supplémentaires remplacées par un repos, majoration comprise. -->
								@if (hasRcr) {
									<tr class="sep">
										<td class="row-label" matTooltip="Heures supplémentaires converties en repos : 1 h à +25 % = 1 h 15">
											Repos compensateur acquis
										</td>
										@for (c of counterCells; track c.key) {
											<td [class.zero]="!c.rcr_credited_min">{{ c.rcr_credited_min ? counterLabel(c.rcr_credited_min) : '—' }}</td>
										}
									</tr>
									<!-- Le repos ouvert par une MAJORATION (dimanche, jour férié travaillé) : il
									     s'ajoute au paiement au lieu de le remplacer. -->
									@if (hasPremiumRest) {
										<tr>
											<td class="row-label" matTooltip="Repos ouvert par les majorations — dimanche ou jour férié
												travaillé qui donne un pourcentage du temps en récupération, EN PLUS de sa majoration">
												+ Récupération des majorations
											</td>
											@for (c of counterCells; track c.key) {
												<td [class.zero]="!c.premium_rest_min">{{ c.premium_rest_min ? counterLabel(c.premium_rest_min) : '—' }}</td>
											}
										</tr>
									}
									<!-- La CONTREPARTIE OBLIGATOIRE EN REPOS, au-delà du contingent annuel. -->
									@if (hasCor) {
										<tr>
											<td class="row-label" matTooltip="Contrepartie obligatoire en repos due au-delà du contingent
												annuel (L3121-30) : 50 % des heures jusqu'à 20 salariés, 100 % au-delà. Elle s'ajoute au
												paiement de l'heure et doit être prise dans les 2 mois.">
												+ Contrepartie obligatoire (COR)
											</td>
											@for (c of counterCells; track c.key) {
												<td [class.zero]="!c.cor_min">{{ c.cor_min ? counterLabel(c.cor_min) : '—' }}</td>
											}
										</tr>
									}
									<tr>
										<td class="row-label">− Repos pris</td>
										@for (c of counterCells; track c.key) {
											<td [class.zero]="!c.rcr_taken_min">{{ c.rcr_taken_min ? counterLabel(-c.rcr_taken_min) : '—' }}</td>
										}
									</tr>
									<tr class="cumul">
										<td class="row-label" matTooltip="Ce que le salarié peut poser en récupération, toutes origines confondues">
											= Solde de récupération
										</td>
										@for (c of counterCells; track c.key) {
											<td [class.over]="c.rcr_balance_min > 0">{{ counterLabel(c.rcr_balance_min) }}</td>
										}
									</tr>
								}
							</tbody>
						</table>
					</div>

					@if (isHrManager) {
						<div class="flexrow adjust-row">
							<mat-form-field class="adjust-hours">
								<mat-label>Ajuster de</mat-label>
								<input matInput type="number" step="0.25" [formControl]="adjustHoursCtrl">
								<span matTextSuffix>h</span>
								<mat-hint>Négatif pour retirer du stock (heures payées)</mat-hint>
							</mat-form-field>
							<mat-form-field class="adjust-comment">
								<mat-label>Motif</mat-label>
								<input matInput [formControl]="adjustCommentCtrl" placeholder="Heures payées sur la paie de juillet">
							</mat-form-field>
							<button mat-stroked-button type="button" (click)="onAddCounterAdjustment()">
								<mat-icon>add</mat-icon>&nbsp;Ajuster
							</button>
						</div>

						@if (counters.length > 0) {
							<ul class="adjust-list">
								@for (c of counters; track c.id) {
									<li class="flexrow">
										<span class="adjust-date">{{ c.dat }}</span>
										<span class="adjust-amount" [class.over]="c.minutes > 0" [class.under]="c.minutes < 0">
											{{ counterLabel(c.minutes) }}
										</span>
										<span class="adjust-why">{{ c.comment }}</span>
										<span class="spacer"></span>
										<button mat-icon-button type="button" matTooltip="Retirer cet ajustement" aria-label="Retirer cet ajustement"
											(click)="onRemoveCounterAdjustment(c)">
											<mat-icon>close</mat-icon>
										</button>
									</li>
								}
							</ul>
						}
					}
				}
			</section>
		}

		<section class="emp-card cp-card">
			<h3><mat-icon>beach_access</mat-icon>Congés payés</h3>

			<!-- L'ANNÉE DE CONGÉS EN COURS — entièrement recalculée depuis les absences, report de
			     l'année précédente compris. C'est le solde que la personne vient chercher. -->
			@if (cpCurrentYear; as cp) {
				<div class="cp-year">
					<div class="cp-year-head">
						<span class="cp-year-label">Année de congés {{ cpPeriodShortLabel(cp.period) }}</span>
						<a routerLink="/hr/leave-closing" class="cp-year-link">Clôtures</a>
					</div>
					<div class="cp-counter">
						@if (cp.carried_in > 0) {
							<div class="cp-item"><span class="val">{{ cpDaysLabel(cp.carried_in) }}</span><span class="lbl">reportés de N-1</span></div>
							<div class="cp-op">+</div>
						}
						<div class="cp-item"><span class="val">{{ cpDaysLabel(cp.acquired_days) }}</span><span class="lbl">acquis sur la période</span></div>
						<div class="cp-op">−</div>
						<div class="cp-item"><span class="val">{{ cpDaysLabel(cp.taken_days) }}</span><span class="lbl">pris</span></div>
						<div class="cp-op">=</div>
						<div class="cp-item solde" [class.negative]="cp.balance_days < 0">
							<span class="val">{{ cpDaysLabel(cp.balance_days) }}</span><span class="lbl">solde</span>
						</div>
					</div>
					@for (w of cp.warnings; track w) {
						<p class="cp-explain aside">{{ w }}</p>
					}
				</div>
			}

			<!-- L'HISTORIQUE DES ANNÉES ARRÊTÉES — tel qu'il a été décidé, pas tel qu'on le
			     recalculerait aujourd'hui. Un arrêté de compte ne se refait pas. -->
			@if (cpClosedYears.length > 0) {
				<h4 class="cp-h4">Années arrêtées</h4>
				<ul class="cp-years">
					@for (y of cpClosedYears; track y.label) {
						<li [matTooltip]="y.period">
							<span class="cp-y-label">{{ y.label }}</span>
							<span class="cp-y-detail">
								@if (y.carried > 0) { {{ cpDaysLabel(y.carried) }} reportés }
								@if (y.lost > 0) { <span class="lost">{{ cpDaysLabel(y.lost) }} perdus</span> }
								@if (y.paid > 0) { {{ cpDaysLabel(y.paid) }} payés }
								@if (y.carried === 0 && y.lost === 0 && y.paid === 0) { rien à reporter }
							</span>
							<span class="cp-y-state" [class.pending]="y.state !== 2">{{ y.stateLabel }}</span>
							@if (y.comment) { <span class="cp-y-comment">{{ y.comment }}</span> }
						</li>
					}
				</ul>
			}
			<!-- CONGÉS NON PRIS EN FIN D'ANNÉE — la règle propre à ce salarié.
			     C'est une PROPOSITION, pas une règle : elle pré-remplit l'arrêté de compte, que le
			     responsable prend ensuite année par année. La raison d'un report (maladie, congés
			     refusés) appartient à l'ANNÉE, pas à la personne — une case cochée pour toujours
			     reporterait encore trois ans plus tard, quand le motif aura disparu. -->
			@if (isHrManager) {
			<h4 class="cp-h4">Congés non pris en fin d'année</h4>
			<mat-checkbox [formControl]="cpCarryoverOwnCtrl" id="cpcarryoverown">
				Règle propre à ce salarié
			</mat-checkbox>
			@if (cpCarryoverOwnCtrl.value) {
				<mat-form-field class="cp-carryover">
					<mat-label>Ses jours non pris sont</mat-label>
					<mat-select [formControl]="cpCarryoverCtrl" id="cpcarryover">
						<mat-option value="carry">Reportés sur l'année suivante</mat-option>
						<mat-option value="lost">Perdus</mat-option>
					</mat-select>
				</mat-form-field>
			}
			<p class="cp-explain aside">{{ cpCarryoverAside }}</p>
			<p class="card-hint">
				Le report n'est pas automatique en droit : les congés non pris sont en principe perdus
				(L3141-12 s.). Il suppose un accord, un usage, ou une impossibilité de les prendre du fait
				de l'employeur — la maladie ouvrant 15 mois. <strong>Ce réglage ne décide de rien</strong> :
				il pré-remplit le formulaire de <a routerLink="/hr/leave-closing">Clôture CP</a>, où la
				décision se prend année par année, avec son motif.
			</p>
			}

			<!-- REPRISE HÉRITÉE — antérieure à la clôture d'année. « Au 1er juin il lui était dû
			     12,5 jours » saisi ici même : une clôture de période écrite au mauvais endroit, qui ne
			     dit ni de quelle année viennent ces jours, ni qui les a arrêtés. Le paramétrage reste
			     réservé au responsable RH (c'est un droit contractuel) ; le solde, lui, s'affiche à
			     l'intéressé — c'est ce qu'il vient chercher. -->
			@if (isHrManager) {
			<h4 class="cp-h4">Reprise saisie sur la fiche</h4>
			@if (leavePeriods.length > 0) {
				<p class="card-hint">
					Ce salarié a des années de congés arrêtées : c'est le compteur ci-dessus qui fait foi.
					Cette reprise n'est conservée que pour mémoire — l'arbitrage se fait désormais dans
					<a routerLink="/hr/leave-closing">Clôture CP</a>.
				</p>
			}
			<div class="flexrow pair">
				<mat-form-field>
					<mat-label>CP dus</mat-label>
					<input matInput type="number" step="0.5" [formControl]="cpBaseDaysCtrl">
					<span matTextSuffix>j</span>
				</mat-form-field>
				<mat-form-field>
					<mat-label>à la date du</mat-label>
					<input matInput [matDatepicker]="cpPicker" [formControl]="cpBaseDateCtrl">
					<mat-datepicker-toggle matIconSuffix [for]="cpPicker"></mat-datepicker-toggle>
					<mat-datepicker #cpPicker></mat-datepicker>
				</mat-form-field>
				<mat-form-field>
					<mat-label>Acquis / mois</mat-label>
					<!-- Pas au demi-jour : le taux des jours OUVRÉS vaut 2,08 — un pas de 0,5 le rendait
					     invalide aux yeux du navigateur, champ en rouge et flèches qui le ramenaient à 2,5. -->
					<input matInput type="number" step="0.01" [formControl]="cpMonthlyCtrl">
					<span matTextSuffix>j</span>
				</mat-form-field>
			</div>
			}
			<!-- Le taux enregistré sur la fiche l'emporte sur celui de l'entreprise : quand les deux
			     diffèrent, on le dit, sinon changer l'unité de décompte laisserait les anciennes
			     fiches sur leur taux d'avant sans que rien ne le signale. -->
			@if (cpMonthlyAside; as aside) {
				<p class="cp-explain aside">{{ aside }}</p>
			}
			@if (cpDetail; as det) {
				<p class="cp-explain">
					Ce salarié gagne <strong>{{ det.monthlyLabel }} j de CP par mois</strong>.
					Depuis le <strong>{{ det.baseDateLabel }}</strong> il s'est écoulé <strong>{{ det.months }} mois</strong>,
					soit <strong>{{ det.gained }} j</strong> acquis en plus des {{ det.baseDays }} j de départ.
				</p>
				<div class="cp-formula">
					<span class="term"><strong>{{ det.baseDays }}</strong> j dus au {{ det.baseDateLabel }}</span>
					<span class="op">+</span>
					<span class="term gain"><strong>{{ det.monthlyLabel }}</strong> j/mois <span class="muted">× {{ det.months }} mois</span></span>
					<span class="op">=</span>
					<span class="term earned"><strong>{{ det.acquired }}</strong> j acquis</span>
				</div>
			}
			<!-- Le compteur hérité ne s'affiche QUE tant qu'aucune année n'a été arrêtée : deux
			     compteurs côte à côte finiraient par annoncer deux soldes différents du même stock. -->
			@if (leavePeriods.length === 0) {
				@if (cpSummary; as cp) {
					<div class="cp-counter">
						<div class="cp-item"><span class="val">{{ cp.acquired }}</span><span class="lbl">acquis à ce jour</span></div>
						<div class="cp-op">−</div>
						<div class="cp-item"><span class="val">{{ cp.taken }}</span><span class="lbl">pris (CP approuvés)</span></div>
						<div class="cp-op">=</div>
						<div class="cp-item solde" [class.negative]="cp.balance < 0">
							<span class="val">{{ cp.balance }}</span><span class="lbl">solde</span>
						</div>
					</div>
				} @else if (isHrManager) {
					<p class="card-hint">
						Aucune reprise saisie. Le solde de l'année en cours se calcule quand même ci-dessus ; pour
						reprendre un solde d'avant le logiciel, arrêtez l'année correspondante dans
						<a routerLink="/hr/leave-closing">Clôture CP</a>.
					</p>
				}
			}
		</section>

		<section class="emp-card abs-card">
			<h3>
				<mat-icon>event_busy</mat-icon>Absences &amp; arrêts
				<span class="spacer"></span>
				<button mat-button type="button" class="years-toggle" (click)="onToggleAllYears()">
					{{ showAllYears ? 'Année en cours' : 'Tout l\'historique' }}
				</button>
			</h3>

			@if (!formGroup.get('id')?.value) {
				<p class="card-hint">Enregistrez la fiche pour saisir les absences.</p>
			} @else {
				<p class="card-hint field-why">
					Saisie directe, y compris rétroactive : un arrêt de 6 mois fractionné en 6 prolongations se saisit
					en 6 lignes.@if (isHrManager) { Approuvées d'office — ce sont des faits constatés, pas des demandes. }
				</p>

				<div class="abs-new">
					<mat-form-field class="abs-typ">
						<mat-label>Type</mat-label>
						<mat-select [formControl]="newAbsTyp">
							@for (t of absenceTypes; track t.id) {
								<mat-option [value]="t.id">{{ t.name }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
					<mat-form-field class="abs-date">
						<mat-label>Du</mat-label>
						<input matInput [matDatepicker]="absStartPicker" [formControl]="newAbsStart">
						<mat-datepicker-toggle matIconSuffix [for]="absStartPicker"></mat-datepicker-toggle>
						<mat-datepicker #absStartPicker></mat-datepicker>
					</mat-form-field>
					<mat-form-field class="abs-date">
						<mat-label>Au</mat-label>
						<input matInput [matDatepicker]="absEndPicker" [formControl]="newAbsEnd">
						<mat-datepicker-toggle matIconSuffix [for]="absEndPicker"></mat-datepicker-toggle>
						<mat-datepicker #absEndPicker></mat-datepicker>
						<mat-hint>Vide = un seul jour</mat-hint>
					</mat-form-field>
					<mat-form-field class="abs-comment">
						<mat-label>Motif / référence</mat-label>
						<input matInput [formControl]="newAbsComment" (keyup.enter)="onAddAbsence()">
					</mat-form-field>
					@if (newAbsenceDays > 0) { <span class="abs-days-preview">{{ newAbsenceDays }} j</span> }
					<button mat-flat-button color="primary" type="button" (click)="onAddAbsence()" [disabled]="addingAbsence">
						<mat-icon>add</mat-icon>&nbsp;{{ addingAbsence ? 'Ajout…' : 'Ajouter' }}
					</button>
				</div>

				@if (absenceRows.length === 0) {
					<div class="abs-empty">Aucune absence {{ showAllYears ? 'enregistrée' : 'cette année' }}.</div>
				} @else {
					<div class="abs-list">
						@for (row of absenceRows; track row.absence.id) {
							<div class="abs-row">
								<span class="abs-dot" [style.background]="row.typColor"></span>
								<span class="abs-type">{{ row.typLabel }}</span>
								<span class="abs-period">{{ row.period }}</span>
								<span class="abs-days">{{ row.days }} j</span>
								<span class="abs-state" [class.approved]="row.state === 1">{{ row.stateLabel }}</span>
								<span class="abs-comment-txt">{{ row.absence.comment }}</span>
								<span class="spacer"></span>
								@if (isHrManager) {
									<button mat-icon-button type="button" matTooltip="Supprimer cette absence" aria-label="Supprimer cette absence" (click)="onDeleteAbsence(row)">
										<mat-icon>delete_outline</mat-icon>
									</button>
								}
							</div>
						}
					</div>
				}
			}

			@if (absenceCounters.length > 0) {
				<div class="abs-counters-title">Total approuvé cette année</div>
				<div class="counters">
					@for (c of absenceCounters; track c.typ) {
						<div class="counter">
							<span class="days">{{ c.days }}</span>
							<span class="label">{{ c.label }}</span>
						</div>
					}
				</div>
			}
		</section>
	</div>
</form>
